import { AllChannelsIcon, Button, EmptyState } from '@buffer-mono/popcorn'

import type { JSX } from 'react'

type NoChannelsFilterEmptyStateProps = {
  onViewDrafts: () => void
}

/**
 * Shown on queue/sent/approvals when "No channels" is selected with no real
 * channel alongside it. Every post belongs to a channel, so those tabs never
 * have channel-less content to show — only the Drafts tab can.
 */
export const NoChannelsFilterEmptyState = ({
  onViewDrafts,
}: NoChannelsFilterEmptyStateProps): JSX.Element => {
  return (
    <EmptyState size="large">
      <EmptyState.Icon>
        <AllChannelsIcon />
      </EmptyState.Icon>
      <EmptyState.Heading>
        The &quot;No channels&quot; filter applies to Drafts only
      </EmptyState.Heading>
      <EmptyState.Description>
        Every post belongs to a channel. Only drafts can be channel-less.
      </EmptyState.Description>
      <EmptyState.Actions>
        <Button onClick={onViewDrafts}>View Drafts</Button>
      </EmptyState.Actions>
    </EmptyState>
  )
}
